import React from 'react';

import { Checkbox } from '@atlaskit/checkbox';

const SyncComments = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur }) => (
  <div style={{ display: 'flex', width: '100%' }}>
    <Checkbox
      isChecked={Boolean(values.sync_comments)}
      onChange={onChange}
      name={`${name}.sync_comments`}
      label="Sync comments & notes"
    />
  </div>
);

export default SyncComments;
